<template>
    <footer class="footer">
        <div class="container-fluid">
            <ul class="nav">
                <li class="nav-item">
                    <a href="#" class="nav-link">
                        {{ siteName }}
                    </a>
                </li>
                <li class="nav-item">
                    <a href="#" class="nav-link">
                        About Us
                    </a>
                </li>
                <li class="nav-item">
                    <a href="#" class="nav-link">
                        Terms and Conditions
                    </a>
                </li>
                <li class="nav-item">
                    <a href="#" class="nav-link">
                        Privacy Policy
                    </a>
                </li>
                <li class="nav-item">
                    <a href="#" class="nav-link">
                        Risk
                    </a>
                </li>
            </ul>
            <div class="copyright">
                © {{ year }} {{ siteName }}
            </div>
        </div>
    </footer>
</template>

<script>
    import {siteName} from "../../config";

    export default {
        name: 'Footer',

        data () {
            return {
                siteName: siteName,
                year: new Date().getFullYear()
            }
        }
    }
</script>